/**
 * Coerce any API error into a plain string safe to hand to toast()/JSX.
 *
 * FastAPI validation errors return `detail` as an ARRAY of objects
 * ({type, loc, msg, input, url}). Rendering that object as a React child throws
 * "React error #31" and unmounts the app (white screen). Always run error text
 * through this before displaying it.
 */
export function errorMessage(err, fallback = 'Something went wrong') {
  // Axios-style error: err.response.data.detail
  const detail = err?.response?.data?.detail ?? err?.detail ?? err;
  return detailToString(detail, err?.message || fallback);
}

export function detailToString(detail, fallback = 'Something went wrong') {
  if (detail == null) return fallback;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    const msgs = detail.map((d) => (d && (d.msg || d.message)) || '').filter(Boolean);
    return msgs.length ? msgs.join(', ') : fallback;
  }
  if (typeof detail === 'object') return detail.msg || detail.message || fallback;
  return String(detail);
}

export default errorMessage;
